import {
  PlatformAIIntelligenceSection,
  PlatformArchitectureFeaturesSection,
  PlatformDeploymentDiagramSection,
  PlatformPrivacySection,
  PlatformSecuritySection,
} from "../components/platform/PlatformSections";
import { Shield } from "lucide-react";
import { MarketingBottomCta } from "../components/MarketingBottomCta";
import { Seo } from "../components/Seo";

export function Platform() {
  return (
    <>
      <Seo
        title="Platform"
        description="Platform overview for security, privacy, architecture, identity, deployment, and the AI intelligence layer. Designed for governance and self-hosting."
        canonicalPath="/platform"
      />
      <div className="bg-slate-950 min-h-screen">
      <section className="relative pt-36 pb-24 overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(5, 150, 105, 0.12) 0%, transparent 60%)",
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(148, 163, 184, 1) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 1) 1px, transparent 1px)",
            backgroundSize: "64px 64px",
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-emerald-500/25 bg-emerald-500/5 text-emerald-400 text-xs uppercase tracking-widest mb-8"
            style={{ fontWeight: 600 }}
          >
            <Shield size={12} />
            Platform & Privacy
          </span>
          <h1
            className="text-slate-100 mb-6"
            style={{
              fontSize: "clamp(2rem, 4.5vw, 3.5rem)",
              fontWeight: 800,
              letterSpacing: "-0.03em",
              lineHeight: "1.1",
            }}
          >
            Your Data Sovereignty.{" "}
            <span
              style={{
                background: "linear-gradient(135deg, var(--color-teal-500, #14b8a6) 0%, var(--color-emerald-500, #10b981) 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Engineered for Global Governance.
            </span>
          </h1>
          <p className="text-on-dark-muted text-lg max-w-2xl mx-auto leading-relaxed">
            DeskReplay was designed from the ground up to support demanding data-protection program goals that global
            enterprises, DPOs, and regulators commonly care about, without compromising operational insight.
          </p>
        </div>
      </section>

      <PlatformSecuritySection />

      <PlatformPrivacySection />

      <PlatformAIIntelligenceSection />

      <section className="py-24 border-t border-slate-800/50">
        <PlatformArchitectureFeaturesSection />
        <PlatformDeploymentDiagramSection />
      </section>

      <MarketingBottomCta
        titleBefore="Ready to keep data in your VPC and still "
        titleAccent="see what happened?"
        description="Walk VPC placement, identity, and retention with engineers, not slideware. We'll connect DeskReplay's topology to how your CISO and DPO already govern evidence."
      />
      </div>
    </>
  );
}
